// REMOVE or COMMENT THIS OUT
document.addEventListener('DOMContentLoaded', function () {
  const scrollWrapper = document.getElementById('google-review-scroll');

  // REMOVE: hover logic
  scrollWrapper.addEventListener('mouseenter', () => {
    scrollWrapper.style.overflowY = 'auto';
  });

  scrollWrapper.addEventListener('mouseleave', () => {
    scrollWrapper.style.overflowY = 'hidden';
  });
});
